angular.module('lf.desktop')

.controller('OrderConfirmationCtrl', function ($scope) {
	// do nothing here.
});
